import { createSignal, For, onCleanup, Show } from "solid-js"
import { convertSizeUnit, throttle } from "../js/utils"
import { InlineUnitSwitch, UnitSwitch } from "./UnitSwitch";
import { Modal, ModalV2 } from "./Modal";

export const SizeGuide = ({ data }) => {
  const fits = data.fits;

  const [visible, setVisibility] = createSignal(false)
  const [selectedFit, setSelectedFit] = createSignal(Object.keys(fits)[0]);
  const [fitData, selectedFitData] = createSignal(fits[Object.keys(fits)[0]]);
  const [selectedUnit, setSelectedUnit] = createSignal(data.unit)
  const handleFitChange = (key) => {
    setSelectedFit(key);
    selectedFitData(fits[key])
  }

  const toggleVisiblity = () => {
    setVisibility(!visible())
  }


  return (<div class="flex flex-col border-frame border-y-outer">
    <div class="flex justify-between p-2">
      <span class="font-bold uppercase text-lg cursor-pointer" onclick={toggleVisiblity}>Size Guide <span class="pr-2 text-ink-link text-sm underline">{visible() ? `Hide` : `Show`}</span></span>
      <Show when={visible()}>
        {/* <UnitSwitch unit={selectedUnit} setUnit={setSelectedUnit} /> */}
      </Show>
    </div>
    <Show when={visible()}>
      <div>
        <div class="flex gap-1 p-2">
          <For each={Object.keys(fits)}>
            {(key, index) => (
              <div class=" border-primary-500 px-2 py-1 cursor-pointer rounded-full"
                onclick={[handleFitChange, key]}
                classList={{ 'bg-primary-500 text-secondary-200': selectedFit() === key }}>
                {fits[key].label}</div>
            )}
          </For>
        </div>

        <div class="pr-2">
          <Show when={fitData().description}>
            <div className="pb-2 px-2" innerHTML={fitData().description} />
          </Show>
          <SizeChart headers={data.headers} selectedUnit={selectedUnit} setSelectedUnit={setSelectedUnit} originalUnit={data.unit} fit={fitData} />
        </div>

      </div>
    </Show>

  </div>)
}

const SizeChart = ({ headers, selectedUnit, setSelectedUnit, originalUnit, fit, context }) => {

  const {
    sizeSettings: {
      standardSizeData,
      handlers: {
        handleAnchorGradedChange
      }
    }
  } = context();
  const selectedId = () => Object.values(standardSizeData().measurements.anchorGraded)[0].selected;
  const handleScroll = (e) => {
    const scrollTarget = e.target
    Array.from(scrollTarget.getElementsByClassName('scrolling-header')).forEach(header => { header.style.transform = `translate3d(${scrollTarget.scrollLeft}px, 0,0` })
  }

  const roundToClosest = (num) => {
    return (selectedUnit() == 'cm' ? Math.round(num * 2) / 2 : Math.round(num * 4) / 4).toFixed(1);
  }

  return (
    <div class="w-full overflow-x-scroll overscroll-x-hidden mx-2 themed-scrollbar border-l-outer border-frame" onScroll={throttle(handleScroll, 50)}>

      <div class="px-[2px] w-max grid relative border-outer border-l-0 border-frame " style={{
        "grid-template-columns": `repeat(${headers.rows.length + 1}, minmax(0, 1fr))`
      }}>

        <div class={`sticky left-0 w-15 px-1 sm:px-2 py-1 whitespace-pre-wrap align-bottom text-center text-sm font-bold bg-canvas border-r-outer border-b-outer border-frame border-solid`}>
          {/* <UnitSwitch unit={selectedUnit} setUnit={setSelectedUnit} buttonClass="h-3" /> */}
          <UnitSwitch unit={selectedUnit} setUnit={setSelectedUnit} buttonClass="!border-outer border-frame border-solid rounded-full items-center w-[34px] h-[22px] bg-secondary-300" buttonContentClass="w-[16px] h-[16px] rounded-full" />
        </div>
        <For each={headers.rows}>
          {(header, index) => (
            <div
              onClick={() => handleAnchorGradedChange(Object.keys(standardSizeData().measurements.anchorGraded)[0], header.id)}
              class={`${index() == headers.rows.length - 1 ? '' : 'border-r-outer'} border-b-outer border-frame border-solid px-1 sm:px-2 whitespace-pre-wrap align-bottom text-center text-sm font-bold flex justify-center items-center uppercase ${selectedId() === header.id ? 'bg-canvas-light' : 'bg-canvas'}`}>
              <span
                class="rounded-full px-2 py-0.5 cursor-pointer"
                classList={{
                  "bg-secondary-300": selectedId() !== header.id,
                  "bg-primary-500 text-canvas": selectedId() === header.id
                }}
              >
                {header.label}
              </span>
            </div>
          )}
        </For>

        <For each={Object.values(headers.columns)} >
          {(column, ind) => {
            return (<>
              {/* <div class={`left-0 col-span-full  border-t-outer border-frame`}>
                <div class="scrolling-header transition-all duration-[75ms] w-fit py-0.5 pl-2 text-left font-medium text-sm">{column.label}</div>
              </div> */}

              <div
                class={`py-1 px-2 border-frame border-r-outer border-solid text-xs sm:text-sm sticky left-0 bg-canvas w-15`}
                classList={{
                  'border-b-outer': headers.columns.length - 1 != ind()
                }}
              >
                {column.label}
              </div>


              <For each={headers.rows.map(row => ({
                isSelected: row.id == selectedId(),
                measurement: fit().sizes[row.id].measurements[column.id]
              }))}>
                {({ isSelected, measurement }, idx) => (
                  <div class={`whitespace-nowrap py-1 px-2 border-frame  border-solid text-xs sm:text-sm text-center flex justify-center items-center`}
                    classList={{
                      'bg-secondary-50': isSelected,
                      'border-b-outer': headers.columns.length - 1 != ind(),
                      'border-r-outer ': headers.rows.length != idx() + 1
                    }}
                  >{roundToClosest(convertSizeUnit(originalUnit, selectedUnit(), measurement.value))} {selectedUnit()}</div>
                )}
              </For>

            </>)
          }}
        </For>


      </div>


    </div>
  )
}

export const SizeGuideV2 = (props) => {

  const [modalState, setModalState] = createSignal(false);
  const data = props.data

  const handleModalOpenState = (state) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = state ? 'hidden' : '';

    setModalState(state);
  }

  onCleanup(() => {
    document.body.style.overflow = "";
  })

  const fits = data.fits;

  const [selectedFit, setSelectedFit] = createSignal(Object.keys(fits)[0]);
  const [fitData, selectedFitData] = createSignal(fits[Object.keys(fits)[0]]);
  const [selectedUnit, setSelectedUnit] = createSignal(data.unit)
  const handleFitChange = (key) => {
    setSelectedFit(key);
    selectedFitData(fits[key])
  }


  return (
    <div>
      <div class="cursor-pointer text-left w-max text-sm text-ink-link hover:text-secondary-400" onClick={() => handleModalOpenState(true)}>
        <svg xmlns="http://www.w3.org/2000/svg" class="size-2 inline-block align-text-bottom" viewBox="0 -960 960 960"><path stroke='currentColor' fill="currentColor" d="M444-288h72v-240h-72v240Zm35.789-312Q495-600 505.5-610.289q10.5-10.29 10.5-25.5Q516-651 505.711-661.5q-10.29-10.5-25.5-10.5Q465-672 454.5-661.711q-10.5 10.29-10.5 25.5Q444-621 454.289-610.5q10.29 10.5 25.5 10.5Zm.487 504Q401-96 331-126q-70-30-122.5-82.5T126-330.958q-30-69.959-30-149.5Q96-560 126-629.5t82.5-122Q261-804 330.958-834q69.959-30 149.5-30Q560-864 629.5-834t122 82.5Q804-699 834-629.276q30 69.725 30 149Q864-401 834-331q-30 70-82.5 122.5T629.276-126q-69.725 30-149 30ZM480-168q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" /></svg>&thinsp;
        Size Guide</div>
      <ModalV2
        title={'Size Guide'}
        modalState={modalState()}
        handleModalOpenState={handleModalOpenState}
      >
        <div class="flex flex-col border-frame border-y-outer w-full">
          <div class="flex justify-end p-2">
            {/* <span class="font-bold uppercase text-lg cursor-pointer">
            Size Guide
          </span> */}
            {/* <UnitSwitch unit={selectedUnit} setUnit={setSelectedUnit} /> */}
          </div>
          <div>
            <div class="flex gap-1 p-2">
              <For each={Object.keys(fits)}>
                {(key, index) => (
                  <div class=" border-primary-500 px-2 py-1 cursor-pointer rounded-full"
                    onclick={[handleFitChange, key]}
                    classList={{ 'bg-primary-500 text-secondary-200': selectedFit() === key }}>
                    {fits[key].label}</div>
                )}
              </For>
            </div>

            <div class="pr-2">
              <Show when={fitData().description}>
                <div className="pb-2 px-2" innerHTML={fitData().description} />
              </Show>
              <SizeChart headers={data.headers} selectedUnit={selectedUnit} setSelectedUnit={setSelectedUnit} originalUnit={data.unit} fit={fitData} context={props?.context}/>
            </div>

          </div>

        </div>
      </ModalV2>
    </div>
  )
}

